
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"app fCCAdvisors"},[_c('overview')],1)}},
      staticRenderFns: []
    };
  


//////////////////
// WEBPACK FOOTER
// ./src/view/app.html
// module id = 13
// module chunks = 0